
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-decisioning/configuration",
      function () {
        return require("private-next-pages/ai-decisioning/configuration.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-decisioning/configuration"])
      });
    }
  